<template>
  <div
    :class="{
      'view-model': !showRemove,
      'file-button': true,
      vertical: direction === 'vertical',
      horizontal: direction === 'horizontal',
    }"
  >
    <img
      @click.stop="onImgClick"
      :src="getUrl(url)"
      class="img-file"
      v-if="isImg()"
    />
    <i @click.stop="onClick" v-if="!isImg()" :class="icon"></i>
    <span
      @click.stop="onClick"
      v-if="!isImg()"
      class="file-name"
      :title="filename"
      >{{ filename }}</span
    >
    <i @click.stop="onRemove" class="el-icon-remove" v-if="showRemove"></i>
  </div>
</template>

<script>
export default {
  name: "FileButton",
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      // --准备文件图标
      fileIcons: {
        DOC: "bi-filetype-doc",
        DOCX: "bi-filetype-docx",
        XLS: "bi-filetype-xls",
        XLSX: "bi-filetype-xlsx",
        PPT: "bi-filetype-ppt",
        PPTX: "bi-filetype-pptx",
        PDF: "bi-filetype-pdf",
        TXT: "bi-filetype-txt",
        XML: "bi-filetype-xml",
        BMP: "bi-filetype-bmp",
        JPG: "bi-filetype-jpg",
        JPEG: "bi-filetype-jpg",
        PNG: "bi-filetype-png",
        GIF: "bi-filetype-gif",
        SVG: "bi-filetype-svg",
        OTHER: "bi-file-earmark",
      },
      imgExt: ["BMP", "JPG", "JPEG", "PNG", "GIF"],
      extension: "",
      icon: "",
    };
  },
  props: {
    filename: {
      type: String,
      default: () => "",
    },
    url: {
      type: String,
      default: () => "",
    },
    direction: {
      type: String,
      default: () => "vertical", // Or horizontal
    },
    showRemove: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    this.getFileExtension();
  },
  methods: {
    getUrl(url) {
      return url.toUpperCase().startsWith('HTTP') ? url : process.env.VUE_APP_BASE_API + url
    },
    isImg() {
      return this.imgExt.includes(this.extension);
    },
    getFileExtension() {
      const extension = this.url.split(".").pop().toUpperCase();
      this.extension = extension;
      const icon = this.fileIcons[extension];
      this.icon = icon || this.fileIcons["OTHER"];
    },
    onRemove() {
      this.$emit("remove");
    },
    onClick() {
      this.$emit("click", this.url);
    },
    onImgClick() {
      this.$emit("imgclick", this.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 50px;
  min-height: 50px;
  height: 110px;
  width: 110px;
  margin: 5px;
  padding: 5px;
  background-color: #fafafa;
  color: #454545;
  transition: all 0.3s linear;
  position: relative;
  overflow: hidden;
  &.view-model {
    background-color: transparent;
  }
  .img-file {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }
  .el-icon-remove {
    font-size: 24px;
    position: absolute;
    right: 1px;
    top: 1px;

    &:hover {
      color: #dc3545;
    }
  }

  &.vertical {
    flex-direction: column;
  }
  &.horizontal {
    flex-direction: row;
  }
  i {
    font-size: 36px;
    &:hover {
      color: #083090;
    }
  }
  .file-name {
    font-size: 11px;
    line-height: 14px;
    height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置方向*/
    -webkit-line-clamp: 2; /*设置超过为省略号的行数*/
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    margin-top: 10px;
    &:hover {
      color: #083090;
    }
  }
}
</style>